// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.\\------packages-common-biz-components-src-banner-index-module__banner-preview-HnR6Km {
  width: 100%;
}

.\\------packages-common-biz-components-src-banner-index-module__banner-preview-HnR6Km .\\------packages-common-biz-components-src-banner-index-module__label-DI2wfE {
  font-size: var(--coze-16);
  color: rgba(var(--coze-fg-white), var(--coze-fg-white-alpha));
  font-weight: 500;
  line-height: 22px;
}

.\\------packages-common-biz-components-src-banner-index-module__banner-preview-HnR6Km .\\------packages-common-biz-components-src-banner-index-module__icon-I1j0Tn path {
  color: rgba(var(--coze-fg-5), var(--coze-fg-5-alpha));
}

.\\------packages-common-biz-components-src-banner-index-module__banner-preview-HnR6Km a {
  font-size: var(--coze-16);
  color: rgba(var(--coze-fg-white), var(--coze-fg-white-alpha));
  font-weight: 500;
  line-height: 22px;
  -webkit-text-decoration-line: underline;
  text-decoration-line: underline;
}

.\\------packages-common-biz-components-src-banner-index-module__banner-preview-HnR6Km a:visited, .\\------packages-common-biz-components-src-banner-index-module__banner-preview-HnR6Km a:active, .\\------packages-common-biz-components-src-banner-index-module__banner-preview-HnR6Km a:focus {
  color: rgba(var(--coze-fg-white), var(--coze-fg-white-alpha));
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"banner-preview": `------packages-common-biz-components-src-banner-index-module__banner-preview-HnR6Km`,
	"bannerPreview": `------packages-common-biz-components-src-banner-index-module__banner-preview-HnR6Km`,
	"label": `------packages-common-biz-components-src-banner-index-module__label-DI2wfE`,
	"icon": `------packages-common-biz-components-src-banner-index-module__icon-I1j0Tn`
};
export default ___CSS_LOADER_EXPORT___;
